export enum TREND_FILTER_TYPE {
	GLUCOSE = "GLUCOSE",
	GLUCOSE_UNLABELED = "GLUCOSE_UNLABELED",
	"GLUCOSE_PRE-MEAL" = "GLUCOSE_PRE-MEAL",
	"GLUCOSE_POST-MEAL" = "GLUCOSE_POST-MEAL",
	GLUCOSE_FASTING = "GLUCOSE_FASTING",
}
